import styled from '@emotion/styled'
import { colors } from '../../shared/ui/colors'

export const PageContainer = styled.div`
  background: ${colors.gray100};
  min-height: 100%;
  padding: 32px 40px;
  box-sizing: border-box;
`

export const ContentCard = styled.div`
  background: ${colors.white};
  border-radius: 24px;
  padding: 32px;
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 21px;
`

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 21px;
`

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
`

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
`

export const Title = styled.h1`
  margin: 0;
  font-size: 1.5rem;
  color: ${colors.gray900};
  font-weight: 500;
`

export const Subtitle = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${colors.gray600};
  max-width: 420px;
`

export const ParamsSelectorWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`

export const ParamsSelectors = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-grow: 1;
`

export const ErrorMessage = styled.span`
  font-size: 12px;
  color: ${colors.status.error.text};
`

export const SummaryCards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(205px, 1fr));
  gap: 14px;
`

export const TableSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 14px;
`

export const SectionTitle = styled.h2`
  margin: 0;
  font-size: 14px;
  line-height: 21px;
  color: ${colors.gray900};
`
